import _defineProperty from "/build-directory/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.sort.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @name ranges-sort
 * @fileoverview Sort string index ranges
 * @version 6.0.13
 * @author Roy Revelt, Codsen Ltd
 * @license MIT
 * {@link https://codsen.com/os/ranges-sort/}
 */

var l = "6.0.13";
var y = l,
  d = {
    strictlyTwoElementsInRangeArrays: !1,
    progressFn: null
  };
function g(t, u) {
  if (!Array.isArray(t) || !t.length) return t;
  var n = _objectSpread(_objectSpread({}, d), u),
    s,
    o;
  if (n.strictlyTwoElementsInRangeArrays && !t.every(function (e, r) {
    return !Array.isArray(e) || e.length !== 2 ? (s = r, o = e.length, !1) : !0;
  })) throw new TypeError("ranges-sort: [THROW_ID_03] The first argument should be an array and must consist of arrays which are natural number indexes representing TWO string index ranges. However, ".concat(s, "th range (").concat(JSON.stringify(t[s], null, 4), ") has not two but ").concat(o, " elements!"));
  if (!t.every(function (e, r) {
    return !Array.isArray(e) || !Number.isInteger(e[0]) || e[0] < 0 || !Number.isInteger(e[1]) || e[1] < 0 ? (s = r, !1) : !0;
  })) throw new TypeError("ranges-sort: [THROW_ID_04] The first argument should be an array and must consist of arrays which are natural number indexes representing string index ranges. However, ".concat(s, "th range (").concat(JSON.stringify(t[s], null, 4), ") does not consist of only natural numbers!"));
  var p = Math.pow(t.length, 2),
    i = 0;
  return Array.from(t).sort(function (e, r) {
    return n.progressFn && (i += 1, n.progressFn(Math.floor(i * 100 / p))), e[0] === r[0] ? e[1] < r[1] ? -1 : e[1] > r[1] ? 1 : 0 : e[0] < r[0] ? -1 : 1;
  });
}
export { d as defaults, g as rSort, y as version };